<template>
    <div class="overlay">
        <div class="overlay_inner connect_broadcasts" :class="{'extended': searchShowsExtended}">
            <div class="field field_search" :class="{'extended': searchShowsExtended}">
              <label for="porad">
                {{$gettext('Pořad')}}
              </label>

              <a class="view_show" v-if="this.selectedShow" @click.prevent="openShowDetail">
                {{$gettext('Přejít na pořad')}}
              </a>

              <input
                id="porad"
                name="porad"
                type="text"
                class="search clearable"
                size="30"
                v-model="searchShowsString"
                :placeholder="$gettext('Hledat podle názvu')"
                autocomplete="off"
                @input="onSearchShowStringChanged"
                @focus="onSearchShowFocus"
                @blur="onSearchShowBlur"
              />

              <a
                v-if="searchShowsString.length > 0"
                id="porad_delete"
                class="clearable_btn"
                style="display:inline"
                :title="$gettext('Vymazat text')"
                @click="eraseSearchShowString"
              >
                {{$gettext('Vymazat')}}
              </a>

              <div class="extended_search" :class="{'extended': searchShowsExtended}">
                  <ul>
                    <li
                      v-for="show in searchedShows"
                      :key="show._id"
                      @click.stop.prevent="onShowSelected(show)"
                    >
                      <a
                        :inner-html.prop="getShowTitle(show) | highlight(searchShowsString)"
                      />
                    </li>
                  </ul>
              </div>
            </div>

            <div class="selected_broadcasts">
              <p class="note">{{$gettext('Vybraná vysílání')}}</p>

              <ul class="broadcasts_list scroll">
                  <li
                    :title="$gettext('Odebrat z výběru')"
                    v-for="broadcast in broadcasts"
                    :key="broadcast._id"
                  >
                    <strong>{{broadcast.name}}</strong> ({{broadcast.tvStation.name}}, {{broadcast.durationMinutes}} min)
                  </li>
              </ul>
            </div>

            <p class="buttons buttons_center">
              <input
                class="btn btn_grey"
                type="submit"
                :value="$gettext('Vytvořit pořad')"
                @click.prevent="goToCreateShowAndPairMultipleBroadcasts"
              />

              <input
                class="btn"
                type="submit"
                :value="$gettext('Navázat')"
                @click.prevent="pairToShowAndClose"
              />
            </p>

            <a
              class="btn btn_action btn_close"
              :title="$gettext('Zavřít')"
              @click.prevent="$emit('close')"
            >
                {{$gettext('Zavřít')}}
            </a>
        </div>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import DropdownInput from '../../../components/DropdownInput.vue'

export default {
  components: { DropdownInput },
  name: 'assign-broadcasts',
  props: {
    broadcastIds: {
      type: Array,
      required: true
    },
    broadcasts: {
      type: Array,
      required: true
    }
  },
  created() {
    let showName = null
    let showId = null
    this.broadcasts.forEach((broadcast) => {
      if (broadcast.show !== null && !showId) {
        showName = broadcast.show.name ? broadcast.show.name : broadcast.show.name ? broadcast.show.originalName : broadcast.show.firstTranslationName
        showId = broadcast.show._id
      }
    })

    if (showId && showName && showName.length > 0) {
      this.searchShowsString = showName
      this.selectShowAfterLoad = showId
      this.requestShows(this.searchShowsString)
    }
  },
  data() {
    return {
      searchShowsExtended: false,
      searchShowsString: '',
      searchedShows: [],
      searchShowsRequestTimer: null,
      selectedShow: null,
      selectShowAfterLoad: null
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.uiLanguages.currentLanguage
    })
  },
  methods: {
    ...mapActions(['getShows', 'assignBroadcasts', 'deleteBroadcast']),
    onSearchShowFocus() {
      this.searchShowsExtended = true
    },
    onSearchShowBlur() {
      setTimeout(() => {
        this.searchShowsExtended = false
      }, 500)
    },
    onSearchShowStringChanged() {
      this.searchedShows = []

      if (this.searchShowsRequestTimer) {
        clearTimeout(this.searchShowsRequestTimer)
        this.searchShowsRequestTimer = null
      }

      if (this.searchShowsString.length > 0) {
        this.searchShowsRequestTimer = setTimeout(() => {
          this.requestShows(this.searchShowsString)
        }, 500)
      }
    },
    requestShows(searchString) {
      this.getShows({
        params: {
          broadcastsAssignable: true,
          createdBy: 'MANUALLY',
          fulltextSearch: true,
          originalNameSearch: true,
          search: searchString,
          order: 'name',
          limit: 100,
          idLanguage: localStorage.ui_language_id
        }
      }).then((response) => this.setShowsToState(response))
    },
    setShowsToState(requestResponse) {
      this.searchedShows = requestResponse.data.data
    },
    eraseSearchShowString() {
      if (this.searchShowsRequestTimer) {
        clearTimeout(this.searchShowsRequestTimer)
        this.searchShowsRequestTimer = null
      }

      this.searchShowsString = ''
      this.searchedShows = []
      this.selectedShow = null
    },
    getShowTitle(show) {
      const name = show.name || show.originalName || show.firstTranslationName

      const details = []
      if (show.genre) {
        details.push(show.genre)
      }

      if (show.yearStart) {
        let year = String(show.yearStart)
        if (show.yearEnd && show.yearStart < show.yearEnd) {
          year += ` - ${show.yearEnd}`
        }
        details.push(year)
      }

      return name + (details.length > 0 ? ' (' + details.join(',') + ')' : '')
    },
    goToCreateShowAndPairMultipleBroadcasts() {
      this.deleteBroadcast({ params: { id: this.broadcastIds[0] } }).then(() => {
        this.$router.push({
          name: 'epg',
          params: {
            id: this.broadcastIds[0]
          },
          query: {
            assign: this.broadcastIds.slice(1).join(','),
            forceNew: true
          }
        })
      })
    },
    removeBroadcast(broadcast) {
      const broadcastIndex = this.broadcasts.indexOf(broadcast)
      this.broadcasts.splice(broadcastIndex, 1)

      const broadcastIdIndex = this.broadcastIds.indexOf(broadcast._id)
      this.broadcastIds.splice(broadcastIdIndex, 1)

      if (this.broadcasts.length == 0) {
        this.$emit('close')
      }
    },
    onShowSelected(show) {
      this.selectedShow = show
      this.searchShowsString = this.getShowTitle(show)
    },
    openShowDetail() {
      const routeData = this.$router.resolve({
        name: 'show',
        params: { id: this.selectedShow._id }
      })

      window.open(routeData.href, '_blank')
    },
    pairToShowAndClose() {
      if (this.selectedShow) {
        this.assignBroadcasts({
          data: {
            broadcastIds: this.broadcastIds,
            showId: this.selectedShow._id
          }
        }).then((response) => {
          this.$emit('paired')
          this.$emit('close')
        })
      }
    }
  },
  watch: {
    searchedShows() {
      if (this.selectShowAfterLoad) {
        this.searchedShows.forEach((show) => {
          if (show._id === this.selectShowAfterLoad) {
            this.onShowSelected(show)
          }
        })

        this.selectShowAfterLoad = null
      }
    }
  }
}
</script>
